import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CourseService } from "../../services/course.service";
import { FormBuilder } from '@angular/forms';





export interface Course {
  _id: string;
  title: string;
  duration: number;
  exams: number;
  type: Number;
};

@Component({
  selector: 'app-add-course-modal',
  templateUrl: './add-course-modal.component.html',
  styleUrls: ['./add-course-modal.component.scss']
})
export class AddCourseModalComponent implements OnInit {
  loading: Boolean = false;
  error: any;
  examDetail: any;
  examArray = [];
  rgba: any;
  always: any;
  policy = false
  allocation = false
  policySequence: any
  trackHours: boolean = false
  hasExam: boolean
  isQuizRelease: boolean
  hasIlpForm: boolean
  componentArray = [
    'construction_L1',
    'customerService_L2',
    'doorSupervisor_L2',
    'level3Diploma_L3',
    'masterRail1_L2',
    'masterRail2_L2',
    'PDE_L1',
    'securityOfficer_L2',
    'Nvq&Techcert_L2',
    'specimanSignature',
    'exerciseReferral'
  ]
  selectedComponent


  ngOnInit() {
    console.log("what is data", this.data);
    this.data['color'] = "#000000"
  }
  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any, public _courseService: CourseService) {
    // NO DEFINITION
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.duration) return false;
    if (!data.title) return false;
    // if (!data.type) return false;
    if (!data.exams) return false;
  }



  doSubmit() {

    console.log("Submit ", this.data);

    // Do Submit
    // this.loading = true;
    if (this.validate(this.data) == false) {
      console.log("RETURNING", this.validate(this.data));
      this.loading = false
      return;
    }
    else {
      this.data['isPolicy'] = this.policy
      this.data['components'] = this.selectedComponent
      this.data['allocation'] = this.allocation
      this.data['trackHours'] = this.trackHours
      this.data['hasExam'] = this.hasExam
      this.data['isQuizRelease'] = this.isQuizRelease
      console.log("policySequence data", this.policySequence);
      if (this.policySequence) {
        let policyName = this.policySequence.split(',')
        console.log("what is the policy list", policyName);
        this.data['policySequence'] = policyName
      }
      // this.data['']
      console.log("API CALLED", this.data)
      this._courseService.addCourse(this.data).subscribe(data => {
        this.data = data;
        this.loading = false;
        this.dialogRef.close(data);
      }, err => {
        console.log("ERROR", err);
        this.loading = false;
        this.error = err.msg
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
